import Drawer from '@mui/material/Drawer';
import useMediaQuery from '@mui/material/useMediaQuery';
import StyleVariables from '../../../assets/styles/variables/_export.module.scss';

export const SCUIGeneralDrawer = (props: any) => {
    const isTablet = useMediaQuery(`(max-width:  ${StyleVariables.breakpointMd})`, { noSsr: true });
    return (
        <Drawer
            sx={
                props.sx
                    ? props.sx
                    : {
                          zIndex: 1300,
                      }
            }
            elevation={0}
            open={props.open}
            onClose={props.onClose}
            anchor={props.anchor ? props.anchor : 'right'}
            hideBackdrop={props.hideBackdrop}
            slotProps={{
                paper: {
                    sx: { width: props.width ? props.width : isTablet ? '100%' : '50%' },
                    ...(props.paperClassName ? { className: props.paperClassName } : {}),
                },
                backdrop: {
                    style: { opacity: 0.2 },
                },
            }}
        >
            {props.children}
        </Drawer>
    );
};
